/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { createSpanFunction } from "@azure/core-tracing";

export const createSpan = createSpanFunction({
  namespace: "Microsoft.CognitiveServices",
  packagePrefix: "Azure.CognitiveServices.AnomalyDetector"
});
